type MemoryWithDeleteAllFlags = {
  is_pinned: boolean;
  memory_type: string;
};

export function filterRemainingMemoriesAfterDeleteAll<T extends MemoryWithDeleteAllFlags>(
  memories: T[],
  keepPinnedMemories: boolean,
  keepManualEntries: boolean,
): T[] {
  if (!keepPinnedMemories && !keepManualEntries) {
    return [];
  }

  return memories.filter((memory) => {
    if (keepPinnedMemories && memory.is_pinned) {
      return true;
    }

    if (keepManualEntries && memory.memory_type === "user") {
      return true;
    }

    return false;
  });
}
